import { AppContext } from "@components/features/appContext/AppContext";
import AlertBox from "@components/primitives/alertBox/AlertBox";
import Layout from "@components/primitives/layout/Layout";
import useFetchMembers from "@hooks/members/useFetchMembers";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { MemberType } from "next-lib";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import Member from "./components/Member";
import jetImage from "@assets/members/jet.jpg";
import johanImage from "@assets/members/johan.jpg";
import juliaImage from "@assets/members/julia.jpg";
import markImage from "@assets/members/mark.jpg";
import martImage from "@assets/members/mart.jpg";
import samrawitImage from "@assets/members/samrawit.jpg";

export const memberImage = {
  jet: jetImage,
  johan: johanImage,
  julia: juliaImage,
  mark: markImage,
  mart: martImage,
  samrawit: samrawitImage,
} as any;

function MembersPage() {
  const { language } = useContext(AppContext);
  const { members } = useFetchMembers(language);

  return (
    <Layout>
      <Helmet>
        <title>{createTitle(translation(language).header.members)}</title>
      </Helmet>
      <div className="h-screen w-full pt-32 pb-20 px-5">
        <h1 className="md:text-3xl text-2xl mb-2">
          {translation(language).members.title}
        </h1>
        <p className="text-secondary">
          {translation(language).members.description}
        </p>
        <div className="mt-8 grid grid-cols-2 gap-6 md:grid-cols-4 bg-primary">
          {members ? (
            members?.length > 0 ? (
              members?.map((member: MemberType) => (
                <Member
                  key={member._id}
                  member={member}
                  memberImage={memberImage}
                />
              ))
            ) : (
              <AlertBox
                type="info"
                message={translation(language).general.error.noDataFound}
              />
            )
          ) : (
            <AlertBox
              type="danger"
              message={translation(language).general.error.somethingWentWrong}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}

export default MembersPage;
